import React, { ChangeEvent, ChangeEventHandler, ReactNode, useEffect, useLayoutEffect, useRef, useState } from 'react';
import MaskedInput from "react-maskedinput";
import CurrencyInput from "react-currency-format";
import { CoreValidatorFunction } from './CoreValidations';
import { JsxElement } from 'typescript';
import { AlertIcon } from '../assets/icons/icon-alert';
import { FileIcon } from '../assets/icons/icon-file';
interface CoreInputProps {
    label?: string;
    readOnly?: boolean;
    name?: string;
    type: "text" | "number" | "date" | "file" | "currency" | "textarea" | "password";
    children?: ReactNode | undefined;
    value?: string | number;
    isDirty?: boolean;
    beforeValue?: (value: string | number) => string | number;

    onChange?: (event?: CoreEventChange) => void;

    afterValue?: (value: string | number) => string | number;

    showSearch?: boolean;
    searchItems?: any[];

    validations?: CoreValidatorFunction[];
    placeholder?: string;

    mask?: string;

    fileAccept?: string;
    group?: string;
    errorIcon?: React.ReactNode

    // Textarea
    rows?: number,
    cols?: number,

    validateOnChange?: string | number;
}


export const CoreInput = (props: CoreInputProps) => {

    // current ref
    const elementRef = useRef<HTMLDivElement>();

    const [errors, setErrors] = useState<string[]>([]);
    const [haserrors, setHasErrors] = useState(false);
    const [dirty, setDirty] = useState(props.isDirty || false);
    const [inFocus, setInFocus] = useState(false);
    const [iValue, setIValue] = useState<string>();

    let value = props.value;

    if (props.beforeValue) {
        let beforeValue = props.beforeValue(value);
        value = beforeValue;
    }


    const validate = (name: string, value: any) => {



        if (props.validations) {

            const results = props.validations.filter(v => v).map(validation => validation(name, value)) || [];
            const newErrors = results.filter(r => !r.valid).map(r => r.error);

            dispatchValidation(results);

            // set errors
            setErrors(newErrors);
            setHasErrors(newErrors.length > 0);
        }
    }

    useEffect(() => {
        validate(props.name, props.value);
    }, [props.validateOnChange])

    const dispatchValidation = (results: CoreValidatorResult[]) => {

        if (!elementRef.current) return;

        const validationEvent = new CustomEvent<CoreValidationResults>(
            "core-input-validation",
            {
                detail: {
                    group: props.group || "",
                    name: props.name,
                    validationResults: results
                },
                bubbles: true
            });

        // dispatch event to coreForm
        elementRef.current.dispatchEvent(validationEvent);
    }



    const onChange = (event: ChangeEvent<HTMLInputElement>) => {

        const name = props.name || "";
        let value = event.target.value;
        let files = event.target.files;

        setIValue(value);
        onValueChange({ name, value, files });


    }

    const onValueChange = ({ name, value, files }: CoreEventChange) => {

        if (props.afterValue) {
            value = props.afterValue(value) as string;
        }



        // dipatch on change to parent
        props.onChange && props.onChange({ name, value, files });

        //trigger validate
        validate(name, value);
    };


    const searchHilight = (text: string, regex: string, className?: string) => {
        var reg = new RegExp(`(${regex})`, "i");
        return text.split(reg).map((s, i) => regex != "" && s.match(reg)
            ?
            <span key={i} className="font-bold">{s}</span>
            :
            <span key={i}>{s}</span>)
    };

    const onSearchClick = (valueClicked: string) => {
        onValueChange({ name: props.name, value: valueClicked });
        setInFocus(false);
    }

    useLayoutEffect(() => {

        setTimeout(() => validate(props.name || "", props.value), 20);

        return () => {

            //clean old errors
            dispatchValidation([]);
        }

    }, [])

    const inputStyle = `
    p-2
    border-2 rounded-md
    border-gray-300 
    hover:border-gray-400 
    text-sm 
    focus:outline-none
      
    ${!haserrors && !props.readOnly && 'active:border-green-600 focus:border-green-600'} 
            
    
    focus:text-gray-800
    text-gray-600
    
    ${props.readOnly && 'bg-gray-100'}
    ${haserrors && !props.readOnly && 'border-red-300 hover:border-red-400 '}
    `;

    return (
        <div className="flex flex-column relative"
            ref={elementRef}

        >
            <label className="px-2 text-sm m-0 text-gray-500" htmlFor={props.name}>{props.label}</label>

            {props.mask &&
                <MaskedInput

                    id={props.name}
                    readOnly={props.readOnly}
                    className={inputStyle}

                    name={props.name}
                    type={props.type}
                    value={value}
                    onBlur={() => { setDirty(true) }}
                    onFocus={() => { setInFocus(true); setDirty(true) }}
                    onChange={onChange}
                    mask={props.mask}
                    accept={props.fileAccept}
                    placeholder={props.placeholder}
                />
            }

            {props.type == "currency" &&
                <CurrencyInput
                    className={inputStyle}
                    value={value}
                    thousandSeparator={"."}
                    decimalSeparator=","
                    prefix={'R$ '}
                    decimalScale={2}
                    onValueChange={({ floatValue }) => onValueChange({ name: props.name, value: floatValue })} />
            }
            {props.type == "textarea" &&
                <textarea
                    id={props.name}
                    readOnly={props.readOnly}
                    className={inputStyle}
                    name={props.name}
                    value={value}
                    onBlur={() => { setDirty(true) }}
                    onFocus={() => { setInFocus(true); setDirty(true) }}
                    onChange={onChange as any}
                    rows={props.rows}
                    cols={props.cols}
                    placeholder={props.placeholder}

                />
            }
            {
                !props.mask &&
                props.type != "textarea" &&
                props.type != "currency" &&
                <input
                    id={props.name}
                    readOnly={props.readOnly}
                    className={inputStyle}
                    placeholder={props.placeholder}
                    name={props.name}
                    type={props.type}
                    style={{ display: props.type == "file" ? "none" : "block" }}
                    value={value}
                    onBlur={() => { setDirty(true) }}
                    onFocus={() => { setInFocus(true); setDirty(true) }}
                    onChange={onChange}
                    accept={props.fileAccept}
                />
            }
            {props.type == "file" &&
                <div className={`flex flex-row items-center`} >
                    <FileIcon size={28} className="stroke-gray-500" />
                    <label className={`cursor-pointer hover:bg-gray-100  ${inputStyle}`} htmlFor={props.name} >{iValue || props.placeholder}</label>
                </div>
            }



            {
                haserrors && !props.readOnly && props.type != "date" && <span className='absolute right-2 top-8 '><AlertIcon size={18} className="stroke-red-500" /></span>
            }


            {/* Search list */}
            {props.showSearch && inFocus &&
                <ul className='absolute top-0 left-0 mt-16 z-10 flex flex-column bg-white w-full overflow-scroll' style={{ maxHeight: "200px" }}>
                    {props.searchItems
                        .filter(s => s.match(new RegExp(`(${value.toString()})`, "i")))
                        .map((s, i) => {
                            return (
                                <li
                                    key={`${props.name}-search-${i}`}
                                    className="flex-1 cursor-pointer hover:bg-gray-200 p-2"
                                    onClick={() => onSearchClick(s)}
                                >
                                    {searchHilight(s, value.toString())}
                                </li>)
                        })}
                </ul>
            }

            {
                haserrors &&
                dirty &&
                !props.readOnly &&
                errors.map((error, i) => <label key={i} className="px-2 text-xs text-red-500 m-0" htmlFor={props.name}>{error}</label>)
            }
        </div>
    )

}